import React from 'react';
import NavBar from '../../components/navbar/navBarComponent';
import Breadcrumb from '../../components/breadcrumb/breadcrumbComponent';
import MenuItem from '../../components/menu/menuItem';

const SurveyPage = (props) => {
  const breadcrumbItems = [
    { name: 'Menu', link: '/menu' },
    { name: 'Encuestas', link: '/surveys' },
  ];

  return (
    <div id="main-news-feed" className="container-fluid page">
      <NavBar cart={props.cart} isLogIn={props.isLogIn} />
      <Breadcrumb page="news-feed-admin" items={breadcrumbItems} />
      <div className="menu-container">
        <MenuItem
          title={'Nueva Encuesta'}
          text={'Crear Nueva Encuesta'}
          icon="quiz"
          link="/surveys-create"
        />
         <MenuItem
          title={'Ver Encuestas'}
          text={'Ver Encuestas Creadas'}
          icon="checklist"
          link="/surveys-list"
        />
      </div>
    </div>
  );
};

export default SurveyPage;
